<div
  class="pay-by-transfer-dialog"
  data-cy="pay-by-transfer"
  [appLoading]="isLoading"
>
  <div class="pay-by-transfer-dialog__container">
    <div class="pay-by-transfer-dialog__heading">
      <h3 class="pay-by-transfer-dialog__title">
        @if (formattedAmount) {
          {{ 'PAY_BY_TRANSFER.TRANSFER_TO_ACCOUNT' | translate: { amount: formattedAmount } }}
        } @else {
          {{ 'PAY_BY_TRANSFER.TRANSFER_HEADING' | translate }}
        }
      </h3>
      <qima-button
        data-cy="pay-by-transfer-download-details"
        [qimaButtonIconName]="qimaIcon.iconName.DOWNLOAD_IMPORT"
        [qimaButtonIconPosition]="qimaIcon.iconPosition.LEFT"
        [qimaButtonLabel]="'PAY_BY_TRANSFER.DOWNLOAD_DETAILS' | translate"
        [qimaButtonSize]="qimaButton.buttonSize.SMALL"
        [qimaButtonStyle]="qimaButton.buttonStyle.TERTIARY"
        (qimaButtonClick)="onPdfDownloadClick()"
      ></qima-button>
    </div>

    <section
      class="pay-by-transfer-dialog__details"
      data-cy="pay-by-transfer-bank-details"
    >
      <p class="pay-by-transfer-dialog__details-label">{{ 'PAY_BY_TRANSFER.BANK_DETAILS' | translate }}</p>
      <ng-template
        #bankDetailCopyButton
        let-copyText="copyText"
      >
        <qima-button-icon
          class="pay-by-transfer-dialog__copy-button"
          appClipboard
          [appClipboardText]="copyText"
          [qimaButtonIconName]="qimaIcon.iconName.DUPLICATE"
          [qimaButtonIconSize]="qimaButton.buttonSize.SMALL"
          [qimaButtonIconStyle]="qimaButton.buttonIconStyle.SECONDARY"
          [attr.aria-label]="'COMMON.COPY' | translate"
          qimaTooltip
          [qimaTooltipHasArrow]="true"
          [qimaTooltipPosition]="qimaTooltip.position.TOP"
          [qimaTooltipStrategy]="qimaTooltip.strategy.ON_HOVER"
          [qimaTooltipStyle]="qimaTooltip.style.DARK"
          [qimaTooltipText]="'COMMON.COPY' | translate"
          (appClipboardCopySuccess)="onBankDetailCopySuccess()"
        ></qima-button-icon>
      </ng-template>
      <ng-template
        #bankDetailField
        let-field="field"
      >
        <div class="pay-by-transfer-dialog__field">
          <div class="pay-by-transfer-dialog__field-copy">
            <span class="pay-by-transfer-dialog__field-label">{{ field.labelKey | translate }}</span>
            <span class="pay-by-transfer-dialog__field-value">{{ field.value }}</span>
          </div>
          @if (field.value) {
            <ng-container *ngTemplateOutlet="bankDetailCopyButton; context: { copyText: field.value }" />
          }
        </div>
      </ng-template>
      @for (row of bankDetailRows; track row.left.labelKey) {
        <div class="pay-by-transfer-dialog__detail-row">
          <ng-container *ngTemplateOutlet="bankDetailField; context: { field: row.left }" />
          <ng-container *ngTemplateOutlet="bankDetailField; context: { field: row.right }" />
        </div>
      }
    </section>

    @if (hasPaymentReference) {
      <section
        class="pay-by-transfer-dialog__reference"
        data-cy="pay-by-transfer-reference-panel"
      >
        <div class="pay-by-transfer-dialog__reference-copy">
          <p class="pay-by-transfer-dialog__reference-kicker">{{ 'PAY_BY_TRANSFER.PAYMENT_REFERENCE_LABEL' | translate }}</p>
          <p class="pay-by-transfer-dialog__reference-hint">{{ 'PAY_BY_TRANSFER.PAYMENT_REFERENCE_FIELD_HINT' | translate }}</p>
        </div>
        <div class="pay-by-transfer-dialog__reference-actions">
          <span
            class="pay-by-transfer-dialog__reference-value"
            data-cy="pay-by-transfer-reference-value"
          >
            {{ paymentReference }}
          </span>
          <qima-button
            data-cy="pay-by-transfer-copy-reference"
            appClipboard
            [appClipboardText]="paymentReference"
            [qimaButtonIconName]="qimaIcon.iconName.DUPLICATE"
            [qimaButtonIconPosition]="qimaIcon.iconPosition.LEFT"
            [qimaButtonLabel]="'COMMON.COPY' | translate"
            [qimaButtonSize]="qimaButton.buttonSize.SMALL"
            [qimaButtonStyle]="qimaButton.buttonStyle.PRIMARY"
            (appClipboardCopySuccess)="onPaymentReferenceCopySuccess()"
          ></qima-button>
        </div>
      </section>

      <section class="pay-by-transfer-dialog__confirm">
        <h4 class="pay-by-transfer-dialog__confirm-title">{{ 'PAY_BY_TRANSFER.CONFIRM_TITLE' | translate }}</h4>
        <p class="pay-by-transfer-dialog__confirm-text">{{ 'PAY_BY_TRANSFER.CONFIRM_DESCRIPTION' | translate }}</p>
        <div
          class="pay-by-transfer-dialog__confirm-box"
          data-cy="pay-by-transfer-confirm-reference"
          role="button"
          tabindex="0"
          (click)="onConfirmBoxClick($event)"
          (keydown.enter)="onConfirmBoxClick($event)"
          (keydown.space)="onConfirmBoxClick($event)"
        >
          <qima-input-checkbox [formControl]="referenceConfirmedControl"></qima-input-checkbox>
          <span class="pay-by-transfer-dialog__confirm-label">
            {{ 'PAY_BY_TRANSFER.CONFIRM_CHECKBOX_BEFORE' | translate }}
            <strong>{{ paymentReference }}</strong>
            {{ 'PAY_BY_TRANSFER.CONFIRM_CHECKBOX_AFTER' | translate }}
          </span>
        </div>

        @if (shouldShowTransactionId) {
          <div
            class="pay-by-transfer-dialog__transaction"
            data-cy="pay-by-transfer-transaction-id"
          >
            <label class="pay-by-transfer-dialog__transaction-label">
              {{ 'PAY_BY_TRANSFER.TRANSACTION_ID' | translate }}
            </label>
            <qima-input-text
              class="pay-by-transfer-dialog__transaction-input"
              [formControl]="transactionIdControl"
              [qimaInputTextId]="'pay-by-transfer-transaction-id'"
              [qimaInputTextPlaceholder]="'PAY_BY_TRANSFER.TRANSACTION_ID_PLACEHOLDER' | translate"
              [qimaInputTextSize]="qimaInput.inputSize.LARGE"
            ></qima-input-text>
          </div>
        } @else {
          <qima-button
            class="pay-by-transfer-dialog__transaction-link"
            data-cy="pay-by-transfer-enter-transaction-id"
            [qimaButtonLabel]="'PAY_BY_TRANSFER.ENTER_TRANSACTION_ID_INSTEAD' | translate"
            [qimaButtonSize]="qimaButton.buttonSize.SMALL"
            [qimaButtonStyle]="qimaButton.buttonStyle.TERTIARY"
            (qimaButtonClick)="onEnterTransactionIdClick()"
          ></qima-button>
        }
      </section>
    }

    <div class="pay-by-transfer-dialog__slip">
      <p class="pay-by-transfer-dialog__slip-label">
        {{ 'PAY_BY_TRANSFER.TRANSFER_SLIP' | translate }}
        <span class="pay-by-transfer-dialog__slip-optional">{{ 'PAY_BY_TRANSFER.OPTIONAL' | translate }}</span>
      </p>
      <div class="pay-by-transfer-dialog__upload">
        <qima-input-file-select
          data-cy="pay-by-transfer-upload"
          class="pay-by-transfer-dialog__upload-control"
          [qimaInputFileSelectAccept]="fileSelectAccept"
          [qimaInputFileSelectIconName]="qimaIcon.iconName.ATTACHMENT"
          [qimaInputFileSelectIsMultiple]="true"
          [qimaInputFileSelectLabel]="'PAY_BY_TRANSFER.UPLOAD_FILE_TIP' | translate"
          (qimaInputFileSelectFilesChange)="onFileSelectFilesChange($event)"
        ></qima-input-file-select>
      </div>
      <p class="pay-by-transfer-dialog__upload-tip">{{ 'PAY_BY_TRANSFER.UPLOAD_FILE_TIP_CONTRACT' | translate }}</p>
      @if (uploadFiles.length > 0) {
        <div class="pay-by-transfer-dialog__files">
          @for (file of uploadFiles; track $index; let idx = $index) {
            <qima-file
              [qimaFileMimeType]="qimaMimeType.APPLICATION_PDF"
              [qimaFileName]="file.name"
              [qimaFileSize]="file.size"
              [qimaFileUploadedSize]="file.size"
              (qimaFileRemove)="onRemoveClick(file, idx)"
            ></qima-file>
          }
        </div>
      }
    </div>

    <qima-button
      class="pay-by-transfer-dialog__submit ga-click-submit-transfer-slip"
      data-cy="pay-by-transfer-submit"
      [qimaButtonIsDisabled]="!canSubmitTransfer"
      [qimaButtonLabel]="'PAY_BY_TRANSFER.MADE_THE_TRANSFER' | translate"
      [qimaButtonSize]="qimaButton.buttonSize.LARGE"
      [qimaButtonStyle]="qimaButton.buttonStyle.PRIMARY"
      [qimaButtonWidth]="qimaButton.buttonWidth.FULL"
      (qimaButtonClick)="onSubmit()"
    ></qima-button>
  </div>
</div>
